// extracted by mini-css-extract-plugin
module.exports = {"error_message":"InfoMessage-module--error_message--22fgK","alarm":"InfoMessage-module--alarm--r2wJK","default":"InfoMessage-module--default--1_daW"};